<ng-container [formGroup]="group">
  <div
    role="group"
    [formGroupName]="model.id"
    [id]="id"
    [ngClass]="[getClass('element', 'control'), getClass('grid', 'control')]"
  >
    <dynamic-material-form-control
      *ngFor="let _model of model.group"
      [group]="control"
      [hidden]="_model.hidden"
      [layout]="formLayout"
      [model]="_model"
      [templates]="templates"
      [hostClass]="[getClass('element', 'children'), getClass('grid', 'children')]"
      (blur)="onBlur($event)"
      (change)="onChange($event)"
      (focus)="onFocus($event)"
      (matEvent)="onCustomEvent($event, null, true)"
    ></dynamic-material-form-control>
  </div>
</ng-container>
